<template>
  <div class="text-center">
    <v-dialog v-model="dataDialog" width="90%">
      <template v-slot:activator="{ on }">
        <v-btn block color="primary" dark v-on="on">{{
          selectedLang.InsertedDataDialogTile1
        }}</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          selectedLang.InsertedDataDialogTile2
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <h2></h2>
          <h3>{{ InsertedDataDialogTile3 }}</h3>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="33" flex-xs="100">
              <div>
                {{ InsertedDataDialogTile4 }}
                <b>{{ firstNum }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ InsertedDataDialogTile5 }}
                <b>{{ pubAL }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ InsertedDataDialogTile6 }}
                <b> {{ selectedCase.text }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="33" flex-xs="100">
              <div>
                {{ InsertedDataDialogTile7 }}
                <b>{{ start }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ InsertedDataDialogTile8 }}
                <b>{{ destination }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div v-html="ansprText"></div>
            </div>
          </div>
          <md-divider></md-divider>
          <h3>{{ selectedLang.InsertedDataDialogTile10 }}</h3>
          <div layout="row" layout-xs="column" layout-align="start center" v-if="kiofCla == 'NB'">
            <div layout-margin flex="70" flex-xs="100">
              <div v-html="formatDBText(selectedLang.InsertedDataDialogTile11, {
                'dataFS.flN': dataFS.flN,
              })
                "></div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile12 }}
                <b>{{ selectedLang.InsertedDataDialogTile13 }}</b>
              </div>
            </div>
          </div>
          <div v-if="kiofCla != 'TRF' && kiofCla != 'TRFDB'" layout="row" layout-xs="column"
            layout-align="start center">
            <div layout-margin flex="70" flex-xs="100">
              <div v-html="formatDBText(selectedLang.InsertedDataDialogTile16, {
                'dataFS.flN': dataFS.flN,
              })
                "></div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile17 }}
                <b>{{ selectMi }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="70" flex-xs="100">
              <div v-html="selectDiText"></div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile19 }}
                <b>{{ answerDi }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center" v-if="selectedAlternativflug == 'Nein'">
            <div layout-margin flex="70" flex-xs="100">
              <div v-html="formatDBText(selectedLang.InsertedDataDialogTile21, {
                'dataFS.flN': dataFS.flN,
              })
                "></div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile19 }}
                <b>{{ selectedAlternativflug }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center" v-if="selectAl == 'Nein'">
            <div layout-margin flex="70" flex-xs="100">
              <div v-html="formatDBText(selectedLang.InsertedDataDialogTile23, {
                'dataFS.flN': dataFS.flN,
              })
                "></div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile24 }}
                <b>{{ selectAl }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center" v-if="selectedCheckIn451 != ''">
            <div layout-margin flex="70" flex-xs="100">
              <div v-html="formatDBText(selectedLang.InsertedDataDialogTile25, {
                'dataFS.flN': dataFS.flN,
              })
                "></div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile28 }}
                <b>{{ selectedCheckIn451 }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center" v-if="selectedCheckIn452 != ''">
            <div layout-margin flex="70" flex-xs="100">
              <div>{{ selectedLang.InsertedDataDialogTile27 }}</div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile28 }}
                <b>{{ selectedCheckIn452 }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center"
            v-if="dataEP.sCase != '' && kiofCla != 'TRF' && kiofCla != 'TRFDB'">
            <div layout-margin flex="70" flex-xs="100">
              <div>{{ selectedLang.InsertedDataDialogTile29 }}</div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile30 }}
                <b>{{ dataEP.sCase }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center" v-if="textReason != ''">
            <div layout-margin flex="70" flex-xs="100">
              <div>{{ selectedLang.InsertedDataDialogTile31 }}</div>
            </div>
            <div layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile32 }}
                <b>{{ textReason }}</b>
              </div>
            </div>
          </div>
          <div v-if="kiofCla != 'TRF' && kiofCla != 'TRFDB'" layout="row" layout-xs="column"
            layout-align="start center">
            <div layout-margin flex="70" flex-xs="100">
              <div>{{ selectedLang.InsertedDataDialogTile33 }}</div>
            </div>
            <div v-if="rd4Upload" layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile34 }}
                <b>{{ selectedLang.InsertedDataDialogTile35 }}</b>
              </div>
            </div>
            <div v-if="!rd4Upload" layout-margin flex="30" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile36 }}
                <b>{{ bsfiles | FilesFormat }}</b>
              </div>
              <div v-if="nsfiles.length">
                <b>{{ nsfiles | FilesFormat }}</b>
              </div>
              <div v-if="ksfiles.length">
                <b>{{ ksfiles | FilesFormat }}</b>
              </div>
              <div v-if="vsfiles.length">
                <b>{{ vsfiles | FilesFormat }}</b>
              </div>
            </div>
          </div>
          <md-divider></md-divider>
          <h3>{{ selectedLang.InsertedDataDialogTile37 }}</h3>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="33" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile38 }}
                <b>{{ user.sex }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile40 }}
                <b>{{ user.fgebu }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="33" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile41 }}
                <b>{{ user.firstName }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile42 }}
                <b>{{ user.lastName }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="33" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile43 }}
                <b>{{ user.address }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile44 }}
                <b>{{ user.city }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="33" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile45 }}
                <b>{{ user.postalCode }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile46 }}
                <b>{{ user.state.val }}</b>
              </div>
            </div>
          </div>
          <div layout="row" layout-xs="column" layout-align="start center">
            <div layout-margin flex="33" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile47 }}
                <b>{{ user.clientMail }}</b>
              </div>
            </div>
            <div layout-margin flex="auto" flex-xs="100">
              <div>
                {{ selectedLang.InsertedDataDialogTile48 }}
                <b>{{ user.telnum }}</b>
              </div>
            </div>
          </div>
          <div v-if="user.companions.length">
            <md-divider></md-divider>
            <h3>{{ selectedLang.InsertedDataDialogTile49 }}</h3>
            <v-row v-for="companion in user.companions" v-bind:key="companion.cfirstName">
              <div layout-margin flex="auto" flex-xs="100">
                <div>
                  {{ companion.csex }} {{ companion.cfirstName }}
                  {{ companion.clastName }},
                  {{ selectedLang.InsertedDataDialogTile51 }}
                  {{ companion.ccomputedDateFormatted }}
                </div>
              </div>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="dataDialog = false">{{
            selectedLang.InsertedDataDialogTile50
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dataDialog: false,
      selectDiText: "",
      ansprText: "",
      InsertedDataDialogTile3: "",
      InsertedDataDialogTile4: "",
      InsertedDataDialogTile5: "",
      InsertedDataDialogTile6: "",
      InsertedDataDialogTile7: "",
      InsertedDataDialogTile8: "",
      InsertedDataDialogTile18a: "",
      pubAL: "",
      start: "",
      destination: "",
      firstNum: "",
      answerDi: "",
    };
  },
  computed: {
    ...mapState([
      "user",
      "dataFS",
      "dataEP",
      "selectedCase",
      "dataTrain",
      "kiofCla",
      "selectMi",
      "selectDi",
      "selectedAlternativflug",
      "selectAl",
      "selectedCheckIn451",
      "selectedCheckIn452",
      "ccomputedDateFormatted",
      "textReason",
      "bsfiles",
      "nsfiles",
      "ksfiles",
      "vsfiles",
      "rd4Upload",
      "selectedLang",
      "itemsJN",
    ]),
  },
  mounted: function () {
    this.answerDi = this.selectDi;
    if (this.kiofCla == "TRF") {
      this.pubAL = this.dateFormat(this.dataFS.times.pubAL);
      this.start = this.dataFS.airports.startAirport.fsidAN;
      this.destination = this.dataFS.airports.targetAirport.fsidAN;
      this.firstNum = this.dataFS.flN;
      this.selectDiText = this.formatDBText(
        this.selectedLang.InsertedDataDialogTile18a,
        { "dataFS.flN": this.dataFS.flN }
      );
      this.ansprText = this.formatDBText(
        this.selectedLang.InsertedDataDialogTile9a,
        { "dataEP.anspr": this.dataEP.anspr }
      );
      this.InsertedDataDialogTile3 = this.selectedLang.InsertedDataDialogTile3;
      this.InsertedDataDialogTile4 = this.selectedLang.InsertedDataDialogTile4;
      this.InsertedDataDialogTile5 = this.selectedLang.InsertedDataDialogTile5;
      this.InsertedDataDialogTile6 = this.selectedLang.InsertedDataDialogTile6;
      this.InsertedDataDialogTile7 = this.selectedLang.InsertedDataDialogTile7;
      this.InsertedDataDialogTile8 = this.selectedLang.InsertedDataDialogTile8;
    } else if (this.kiofCla == "TRFDB") {
      this.answerDi = this.itemsJN[0].state;
      // this.pubAL = this.dataTrain.travelDate;
      // this.start = this.dataTrain.start;
      // this.destination = this.dataTrain.destination;
      this.firstNum = this.dataTrain.bookingCode;
      this.selectDiText = this.formatDBText(
        this.selectedLang.InsertedDataDialogTile18aDB,
        { "bookingCode": this.dataTrain.bookingCode }
      );
      this.InsertedDataDialogTile3 =
        this.selectedLang.InsertedDataDialogTile3DB;
      this.InsertedDataDialogTile4 =
        this.selectedLang.InsertedDataDialogTile4DB;
      this.InsertedDataDialogTile5 =
        this.selectedLang.InsertedDataDialogTile5DB;
      this.InsertedDataDialogTile6 =
        this.selectedLang.InsertedDataDialogTile6DB;
      this.InsertedDataDialogTile7 =
        this.selectedLang.InsertedDataDialogTile7DB;
      this.InsertedDataDialogTile8 =
        this.selectedLang.InsertedDataDialogTile8DB;
    } else {
      this.pubAL = this.dateFormat(this.dataFS.times.pubAL);
      this.start = this.dataFS.airports.startAirport.fsidAN;
      this.destination = this.dataFS.airports.targetAirport.fsidAN;
      this.firstNum = this.dataFS.flN;
      this.selectDiText = this.formatDBText(
        this.selectedLang.InsertedDataDialogTile18,
        { "dataFS.flN": this.dataFS.flN }
      );
      this.ansprText = this.formatDBText(
        this.selectedLang.InsertedDataDialogTile9,
        {
          "dataEP.anspr": this.dataEP.anspr,
        }
      );
    }
  },
  methods: {
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    dateFormat(date) {
      const event = new Date(date);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return event.toLocaleDateString("de-DE", options);
    },
  },
  filters: {
    FilesFormat: function (date) {
      let dataString = "";
      date.forEach(function (item) {
        dataString = dataString.concat(item.name, ",");
      });
      return dataString;
    },
  },
};
</script>
